import { render } from "./AdminProfileScreen.vue?vue&type=template&id=6d36da94&scoped=true"
import script from "./AdminProfileScreen.vue?vue&type=script&lang=js"
export * from "./AdminProfileScreen.vue?vue&type=script&lang=js"

import "./AdminProfileScreen.vue?vue&type=style&index=0&id=6d36da94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d36da94"]])

export default __exports__